import React from 'react'
import HeaderFour from '../header/HeaderFour';
import Project from './breadcrumb/Project';
import Portfolio from '../home/Portfolio';
import Footer from '../elements/Footer';
import { Link } from 'react-router-dom';
import HeaderNew from '../header/HeaderNew';

function Appoinment() {
  return (
    <div className='service-details'>
      <div className="">
        <HeaderNew/>
        <main>
          {/* <div className="breadcrumb-area bg_image tmp-section-gap "
            style={{ backgroundImage: `url(assets/images/breadcrumb/portfolio.webp)` }}>
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="breadcrumb-inner text-center">
                    <h1 className="title split-collab">Recent Project</h1>
                    <ul className="page-list">
                      <li className="tmp-breadcrumb-item">
                        <a href="/">Home</a>
                      </li>
                      <li className="icon">
                        <i className="fa-solid fa-angle-right" />
                      </li>
                      <li className="tmp-breadcrumb-item active">Recent Project</li>
                    </ul>
                    <div className="circle-1" />
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          <div className="my-5 pt-5">
            <Portfolio />
          </div>
          <Footer />
        </main>
      </div>
    </div>
  )
}

export default Appoinment